module.exports = {"TXTCLI_Share_viaX":{"id":"TXTCLI_Share_viaX","defaultMessage":"Κοινή χρήση μέσω:"}}